module.exports = __webpack_public_path__ + "static/media/purple.d708c9fd.JPG";